import { ManualEventType } from "../../codegen/graphql";

/**
 * Wizard event types after which a declaration of contamination is offered.
 * ASSET_DELETE also decomposes into a REMOVE event server-side, but the wizard
 * deliberately offers no declaration for a deletion (the pump is scrapped, not
 * shipped); the event views still treat that REMOVE like any other.
 */
export const CONTAMINATION_DECLARATION_EVENT_TYPES: ReadonlyArray<ManualEventType> = [
    ManualEventType.ASSET_REMOVE,
    ManualEventType.ASSET_EXCHANGE,
];

export interface ContaminationDeclarationOfferContext {
    eventType: ManualEventType | null | undefined;
    canCreate: boolean;
    enabled: boolean;
    /**
     * `contaminationDeclarationAvailability` for the ASSET_REMOVE event this
     * wizard run produced: the form is currently US-only, gated on the owning client's
     * CRM region. False for every other region, and false whenever the answer
     * could not be obtained — never offer a follow-up the server would refuse.
     */
    available: boolean;
}

export const shouldOfferContaminationDeclaration = ({
    eventType,
    canCreate,
    enabled,
    available,
}: ContaminationDeclarationOfferContext): boolean =>
    enabled && canCreate && available && !!eventType && CONTAMINATION_DECLARATION_EVENT_TYPES.includes(eventType);
